import styled from '@emotion/styled'

export const StylePhoneInputWrapper = styled.div<any>`
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : !!props?.isFocus
          ? props.theme.colors.primary
          : props.theme.colors.inputBorder};
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding-right: 10px;
  position: relative;
  overflow: hidden;
  outline: none;
  ${(props) => props.styleInput}
`

export const StylePhoneInput = styled.input<any>`
  border: 0px;
  width: calc(100% - 50px);
  outline: none;
  height: 40px;
  padding: 0px;
  background-color: transparent;
  color: ${(props) => props.theme.colors.text};
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Lato;
  }
`

export const StyleCountryCodeDropDown = styled.div<any>`
  width: 50px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`

export const StyleSelectedCountryCode = styled.p<any>`
  font-size: 12px;
  color: ${(props) => props.theme.colors.text};
`

export const StyleDropDownOptionWrapper = styled.div<any>`
  width: 100%;
  background: ${(props) =>
    props.theme.colors.surface || props.theme.colors.white};
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 1111;
  top: 80px;
`
export const StyleDropDownOptionItems = styled.ul<any>`
  width: 100%;
  background: transparent;
  max-height: 150px;
  overflow-y: auto;
`
export const StyleDropDownOption = styled.li<any>`
  padding: 7px 10px;
  font-size: 12px;
  background: ${(props) =>
    props.isActive ? props.theme.colors.primary : 'transparent'};
  color: ${(props) => (props.isActive ? '#fff' : props.theme.colors.text)};
  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: #fff;
  }
`

export const StyleDropDownSearchWrapper = styled.div<any>`
  padding: 10px 10px;
`
export const StyleDropDownSearchInput = styled.input<any>`
  width: 100%;
  border-radius: 4px;
  height: 40px;
  text-indent: 10px;
  padding: 0px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  background-color: transparent;
  color: ${(props) => props.theme.colors.text};
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Inter;
  }
`
